import { TimeFormatUtils } from '../utilities/time-format.utils';

export class TimeSlotApiFormat {
  day: number; // 0-indexed, Sunday-Saturday
  start: string; // e.g. '09:00'
  end: string; // e.g. '17:00'

  constructor(obj: any) {
    this.day = obj.day;
    this.start = TimeFormatUtils.convertToApiTimeFormat(obj.start);
    this.end = TimeFormatUtils.convertToApiTimeFormat(obj.end);
  }
}

export class WeeklySchedule {
  timezone: string;
  slots: TimeSlotApiFormat[];

  constructor(obj: any) {
    this.timezone = obj?.timezone;
    this.slots = obj?.slots?.map((slot: any) => new TimeSlotApiFormat(slot)) || [];
  }
}
